module.exports = __webpack_public_path__ + "6c48ce739e7f336105fb5802689b6601.png";